module.exports = __webpack_public_path__ + "img/hazardEquip75.385e5b99.jpg";